<template lang="pug">
.indicadores-capacidade-produtiva
    .indicador(v-for='campo in campos' :key='campo.chave')
        el-tooltip(:content='campo.tooltip' placement='top')
            small.d-block.text-muted.indicador__rotulo
                i.mdi.mdi-information-outline.mr-1
                | {{ campo.rotulo }}
        strong.indicador__valor {{ campo.valor }}
        small.d-block.text-muted(v-if='campo.sacas') {{ campo.sacas }}
</template>

<script>
/**
 * Área produtiva, Produtividade e Capacidade produtiva de uma cultura, cada campo com ícone de informação e
 * tooltip (RN31 da spec GS-3925 v9). Mirror do bloco do PS (DiagnosticosSocioambientais.vue:344-366, ícone
 * mdi-information-outline no rótulo). Os textos são os da RN31 v9: "Área plantada da cultura somada à área de
 * pastagem do imóvel" (Área produtiva), "Fonte: Companhia Nacional de Abastecimento" (Produtividade) e
 * "(Área Produtiva x Produtividade) x 1,15" (Capacidade produtiva), este último com o fator 1,15.
 *
 * Recebe os valores já formatados (`indicadoresCapacidade`, utils/produtividadeCultura.js).
 */
export default {
    name: 'IndicadoresCapacidadeProdutiva',
    props: {
        indicadores: { type: Object, required: true }
    },
    computed: {
        campos() {
            return [
                {
                    chave: 'area',
                    rotulo: this.$t('mensagens.diagnosticoSocioambiental.areaProdutiva'),
                    tooltip: this.$t('mensagens.diagnosticoSocioambiental.tooltipAreaProdutiva'),
                    valor: this.indicadores.area
                },
                {
                    chave: 'produtividade',
                    rotulo: this.$t('mensagens.diagnosticoSocioambiental.produtividade'),
                    tooltip: this.$t('mensagens.diagnosticoSocioambiental.fonteCapacidadeProdutiva'),
                    valor: this.indicadores.taxa,
                    sacas: this.indicadores.taxaSacas
                },
                {
                    chave: 'capacidade',
                    rotulo: this.$t('mensagens.diagnosticoSocioambiental.capacidadeProdutiva'),
                    tooltip: this.$t('mensagens.diagnosticoSocioambiental.tooltipCapacidadeProdutiva'),
                    valor: this.indicadores.capacidade,
                    sacas: this.indicadores.capacidadeSacas
                }
            ];
        }
    }
};
</script>

<style lang="scss" scoped>
.indicadores-capacidade-produtiva {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
}

.indicador__rotulo {
    cursor: help;
}

.indicador__valor {
    display: block;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.3;
}

@media (max-width: 520px) {
    .indicadores-capacidade-produtiva {
        grid-template-columns: 1fr;
    }
}
</style>
